import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bookmarkFacility } from 'actions';

class Bookmark extends Component {
    bookmarkToggle = () => {
        const {
            facility_id,
            bookmark,
            bookmark_id,
        } = this.props;

        this.props.bookmarkFacility({ facility_id, direction: !bookmark, bookmark_id });
    };

    render() {
        const {
            bookmark,
            bookmark_loading,
        } = this.props;

        const icon = !bookmark ? '-o' : '';
        const label = bookmark ? 'ed' : '';

        return (
          <div onClick={this.bookmarkToggle} className="d-flex align-items-center gap-xs-2 bookmark facility-bookmark">
            {bookmark_loading
                    ? (
                      <>
                        <i className="fa fa-2x action-item-icon fa-spin fa-spinner" />
                        <span className="action-item-label">
                          Saving
                        </span>
                      </>
                )
                : (
                    <>
                        <i className={`fa fa-2x action-item-icon fa-bookmark${icon}`}/>
                        <span className="action-item-label">
                          Bookmark
                            {label}
                        </span>
                    </>
                )}
          </div>
        );
    }
}

const mapStateToProps = ({ facility }) => {
    const {
        facility_id = false,
        user: {
            bookmark_id = false,
        } = {},
    } = facility.data.facility;

    const bookmark = !!bookmark_id;

    const { bookmark_loading } = facility;

    return {
        bookmark,
        bookmark_loading,
        facility_id,
        bookmark_id,

        facility: facility.data.facility,
    };
};

export default connect(mapStateToProps, { bookmarkFacility })(Bookmark);
